
<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Uygulama Ayarları</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Uygulamalar</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Uygulamalar
                <div class="float-right">
                  <button class="btn  btn-sm mx-2" :class="appUserStatus ? 'btn-primary' : 'btn-danger'" @click="updateAppUserStatus" v-if="auth.AppSetting != null && auth.AppSetting.isWrite">
                    Girişi Devre Dışı Bırak
                  </button>
                  <button class="btn btn-primary btn-sm mx-2" @click="getPasswordModal" v-if="auth.AppSetting != null && auth.AppSetting.isWrite">
                    <i class="fas fa-plus"></i> Şifre Değişikliği
                  </button>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th style="width: 1%">#</th>
                        <th>Uygulama Adı</th>
                        <th>Uygulama Durum</th>
                        <th>Backoffice Hesabı</th>
                        <th style="min-width: 250px" v-if="auth.AppSetting != null && auth.AppSetting.isWrite"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in datatable" :key="item.id">
                        <td>#</td>
                        <td>
                          <a> {{ item.name }} </a>
                        </td>
                        <td>
                          <badge :type="item.isActive ? 'success' : 'danger'"
                            :label="item.isActive ? 'Kullanılabilir' : 'Kullanılamaz'" />

                        </td>
                        <td>
                          <badge v-if="item.isDagur" :type="item.isDagur ? 'success' : 'danger'"
                            :label="item.isDagur ? 'Backoffice Kullanıcısı Lazım' : ''" />

                        </td>
                        <td class="project-actions text-right" v-if="auth.AppSetting != null && auth.AppSetting.isWrite">
                          <router-link tag="button" :to="'/apps/users/' + item.id" class="btn btn-outline-primary btn-sm"
                            title="Kullancılar">
                            <i class="fas fa-users"> </i>
                          </router-link>
                          <button class="btn btn-outline-info btn-sm" @click="getModal(item)" title="Düzenle">
                            <i class="fas fa-pencil-alt"> </i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="datatable.length == 0">
                        <td colspan="6" class="text-center">
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="perPage" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->

    <!--Password UpdateModal-->
    <div class="modal fade" id="passwordModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Sifre Düzenleme
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">

              <div class="form-group">
                <label>Şifre</label>
                <input
                  @blur="$v.user.password.$touch()"
                  v-model="$v.user.password.$model"
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.password.$error }"
                  placeholder="Şifre giriniz"
                />
                <small
                  v-if="!$v.user.password.required && $v.user.password.$error"
                  class="form-text text-danger"
                >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group">
                <label>Şifreyi Onayla</label>
                <input
                  @blur="$v.user.confirmPassword.$touch()"
                  v-model="$v.user.confirmPassword.$model"
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.confirmPassword.$error }"
                  placeholder="Şifre Onayla giriniz"
                />
                <small
                  v-if="!$v.user.confirmPassword.required && $v.user.confirmPassword.$error"
                  class="form-text text-danger"
                >Bu alan zorunludur...</small
                >
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="updatePassword()"
              :disabled="$v.user.$invalid"
            >
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>


    <!--Modal-->
    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Uygulama Düzenleme</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Uygulama Adı</label>
                <input @blur="$v.app.name.$touch()" v-model="$v.app.name.$model" type="text" class="form-control"
                  :class="{ 'is-invalid': $v.app.name.$error }" placeholder="Uygulama adını giriniz" />
                <small v-if="!$v.app.name.required && $v.app.name.$error" class="form-text text-danger">Bu alan
                  zorunludur...</small>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              İptal
            </button>
            <button type="button" class="btn btn-primary" @click="save()" :disabled="$v.app.$invalid">
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
import { required } from "vuelidate/lib/validators";
import Badge from "../Common/Badge";

export default {
  data() {
    return {
      auth: this.$store.getters.getModules,
      page: 1,
      perPage: 10,
      rows: 0,
      apps: null,
      appUserStatus: true,
      datatable: [],
      overlay: false,
      app: {
        name: "",
      },
      user: {
        password: "",
        confirmPassword: ""
      },
      appUserStatusModel: {
        status: true,
      },
    };
  },
  validations: {
    app: {
      name: {
        required,
      },
    },
    user: {
      password: {
        required,
      },
      confirmPassword: {
        required,
      },
    },
  },
  components: {
    'badge': Badge,
  },
  methods: {
    pagination(value) {
      var count = (value - 1) * this.perPage;
      this.datatable = this.apps.slice(count, count + this.perPage);
    },
    getDatas() {
      this.overlay = true;
      this.$http.get("App/ListApps").then((response) => {
        this.apps = response.data;
        this.datatable = this.apps.slice(0, this.perPage);
        this.rows = this.apps.length;
        this.overlay = false;
      });
    },
    getAppUserStatus() {
      this.$http.get("AppUser/CheckDisabledAppUser").then((response) => {
        if(response.status === 200) {
          this.appUserStatus = false;
        }
        else {
          this.appUserStatus = true;
        }
      }).catch((error) => {
        this.appUserStatus = true;
      });
    },
    getModal(value) {
      this.app = value;

      $("#modal").modal();
    },
    getPasswordModal() {
      $("#passwordModal").modal();
    },
    save() {
      this.$http
        .get("App/EditApp/" + this.app.id + "?name=" + this.app.name)
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          $("#modal").modal("hide");
          this.getDatas();
          this.getAppUserStatus();
        });
    },
    updatePassword() {
      this.overlay = true;
      let url = "AppUser/UpdateAllPassword";
      this.$http.post(url, this.user).then(
        (response) => {
          toastr.success("Kayıt başarılı.");
          $("#passwordModal").modal("hide");
          this.getDatas();
          this.getAppUserStatus();
        },
        (error) => {
          toastr.error(error.data.Message);
        }
      );
    },
    updateAppUserStatus() {
      debugger;
      this.overlay = true;
      this.appUserStatusModel.status = !this.appUserStatus
      this.$http.post("AppUser/UpdateAppUserStatus", this.appUserStatusModel).then((response) => {
        if(response) {
          this.getAppUserStatus();
          this.getDatas();
        }
      });
    },
  },

  created() {
    this.getDatas();
    this.getAppUserStatus();
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/App/AppList.vue